import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ILocationOption } from '@types-custom/models/business/location.model';
import { Icon } from '@types-custom/models/ui/icon-model';

@Component({
  selector: 'dropdown-filter',
  templateUrl: './dropdown-filter.component.html',
  styleUrls: ['./dropdown-filter.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownFilterComponent),
      multi: true
    }
  ]
})
export class DropdownFilterComponent implements ControlValueAccessor {
  @Input() formControl: FormControl;
  @Input() options: ILocationOption[];
  @Input() formControlName: string;
  @Input() label: string;

  Icon = Icon
  toggler = false;

  get icon() {
    return Icon;
  }

  private _value = '';

  onChange = (_: unknown) => { return; };
  onTouched = () => { return; };

  @Input()
  get value(): string {
    return this._value;
  }

  set value(val: string) {
    this._value = val;
    this.onChange(val);
  }

  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.value = value;
  }
}
